import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import VerticalTabs from "src/components/shared/vertical-tabs/VerticalTabs";
import { setSelectedItem } from "src/store/reservations/slices/ReservationsManagerSlice";
import RateSummarySection from "./RateSummarySection";

const ManageTabItem = ({ selectedItem }) => {
  const dispatch = useDispatch();
  const { isDetailView, reservationOverview } = useSelector( (state) => state.reservationsSummaryReducer );

  // Dynamically generate tabs based on selected item
  const tabs = useMemo(() => {
    if (!selectedItem) return [];

    // Check if selected item is a Hotel
    if (selectedItem.PropertyId) {
      const hotel = reservationOverview?.Hotels?.find( (h) => h.PropertyId === selectedItem.PropertyId );

      if (hotel && hotel.Rooms && hotel.Rooms.length > 0) {
        return hotel.Rooms.map((room, index) => ({
          value: `${index + 1}`,
          label: `Group ${String(index + 1)}`,
          component: (
            <RateSummarySection 
              isView={isDetailView} 
              roomData={room}
              roomIndex={index}
              hotelData={hotel}
            />
          ),
        }));
      }
    }
    
    // Check if selected item is a Service
    if (selectedItem.ServiceId) {
      const service = reservationOverview?.Services?.find( (s) => s.ServiceId === selectedItem.ServiceId );

      if (service && service.Units && service.Units.length > 0) {
        return service.Units.map((unit, index) => ({
          value: `${index + 1}`,
          label: `Group ${String(index + 1).padStart(2, '0')}`,
          component: (
            <RateSummarySection 
              isView={isDetailView} 
              unitData={unit}
              unitIndex={index}
              serviceData={service}
            />
          ),
        }));
      }
    }

    return [];
  }, [selectedItem, reservationOverview, isDetailView]);

  useEffect(() => {
    return () => {
      dispatch(setSelectedItem(null));
    };
  }, [dispatch]);

  if (tabs.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No rate details available for this item.
        </Typography>
      </Box>
    );
  }

  return <VerticalTabs tabList={tabs} />;
};

export default ManageTabItem;